/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coaching_Ceiling_WarningInputs */

const en_us2_coaching_ceiling_warning = /** @type {(inputs: Coaching_Ceiling_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The group has more than ${i?.count} students. Everything keeps working.`)
};

const pt_br2_coaching_ceiling_warning = /** @type {(inputs: Coaching_Ceiling_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A turma passou de ${i?.count} alunos. Tudo continua funcionando.`)
};

const pt_pt2_coaching_ceiling_warning = /** @type {(inputs: Coaching_Ceiling_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A turma passou de ${i?.count} alunos. Tudo continua funcionando.`)
};

/** @type {(inputs: Coaching_Ceiling_WarningInputs) => LocalizedString} */
const es_419_coaching_ceiling_warning = en_us2_coaching_ceiling_warning;

/** @type {(inputs: Coaching_Ceiling_WarningInputs) => LocalizedString} */
const fr_fr2_coaching_ceiling_warning = en_us2_coaching_ceiling_warning;

/** @type {(inputs: Coaching_Ceiling_WarningInputs) => LocalizedString} */
const de_de2_coaching_ceiling_warning = en_us2_coaching_ceiling_warning;

/** @type {(inputs: Coaching_Ceiling_WarningInputs) => LocalizedString} */
const it_it2_coaching_ceiling_warning = en_us2_coaching_ceiling_warning;

/**
* | output |
* | --- |
* | "The group has more than {count} students. Everything keeps working." |
*
* @param {Coaching_Ceiling_WarningInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_ceiling_warning = /** @type {((inputs: Coaching_Ceiling_WarningInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Ceiling_WarningInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_ceiling_warning(inputs)
	if (locale === "es-419") return es_419_coaching_ceiling_warning(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_ceiling_warning(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_ceiling_warning(inputs)
	if (locale === "de-DE") return de_de2_coaching_ceiling_warning(inputs)
	if (locale === "it-IT") return it_it2_coaching_ceiling_warning(inputs)
	return en_us2_coaching_ceiling_warning(inputs)
});
export { coaching_ceiling_warning as "coaching.ceiling_warning" }